<ul class="layout-menu">
    <!------------------------------------------------------------------------------------------>
    <li>
        <div class="flex flex-column">
            <div class="flex align-items-center justify-content-center">
                <p-avatar 
                    :image="user.photo" 
                    :icon="!user.photo ?  'pi pi-user' : ''" 
                    shape="circle" 
                    style="background-color: #2196f3; color: #ffffff"
                    size="xlarge"
                >
                </p-avatar>
            </div>
            <div class="flex align-items-center justify-content-center font-bold p-2">
                {{user.name}}
            </div>
            <div class="flex align-items-center justify-content-center">
                <i>{{user.email}}</i>
            </div>
        </div>
    </li>
    <li><hr></li>
    <!------------------------------------------------------------------------------------------>
    <template v-for="(item, i) in item_side_menu" :key="item">
        <app-side-item v-if="!item.separator" :item="item" :index="i"></app-side-item>
        <li v-if="item.separator" class="menu-separator"></li>
    </template>
    <!------------------------------------------------------------------------------------------>
    
</ul>